import React, { useState, useEffect } from 'react';
import { AgGridReact } from 'ag-grid-react';
import CollectorClaimModal from '../Claims/ClaimModal/CollectorClaimModal';
import useFetch from '../Utilities/useFetch';
import { Button, Row, Col, Form } from 'react-bootstrap';
import Select from 'react-select';

const ReportTemplateCSVClick = ({
    columnDefs,
    apiUrl,
    reportName
}) => {
    const [selectedDebtorId, setSelectedDebtorId] = useState(null);
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [gridApi, setGridApi] = useState();
    const [selectedClient, setSelectedClient] = useState(null);
    const [clientOptions, setClientOptions] = useState([]);
    
    // Build params object for API call
    const apiParams = selectedClient?.value ? { clientid: selectedClient.value } : {};
    const { data: rowData, error } = useFetch(
        true, // Always fetch
        apiUrl,
        'GET',
        null,
        apiParams
    );
    const { data: clients } = useFetch(true, `${process.env.REACT_APP_API_URL}/Claims/GetClients`, 'GET');

    useEffect(() => {
        if (clients) {
            const options = clients.map((client) => ({
                value: client.key,
                label: client.value,
            }));
            setClientOptions([{ value: null, label: 'All Clients' }, ...options]);
        }
    }, [clients]);
   const onBtnExport = () => {
        const textColumns = ['Claim ID','clientRefNo', 'RefNo']; // columns to format as text
        const dateColumns = ['listDate','serviceDate','arbHearingDate','accountStatusDate','depositDate','dateReceived','dateRemitted']; // columns to format as date
        gridApi.exportDataAsCsv({
        processCellCallback: (params) => {
            if (textColumns.includes(params.column.getColId())) {
                return params.value != null ? "'" + params.value : '';
            }
            if (dateColumns.includes(params.column.getColId())) {
                if (params.value == null) return '';
                const date = new Date(params.value);
                // convert to standard date string
                const formattedDate = isNaN(date.getTime()) ? '' : date.toLocaleDateString();

                return formattedDate;
            }
            return params.value;
            }
        });
    }  
  const onGridReady = (params) => {
        setGridApi(params.api);
    }

    if (error) {
        console.error('Error fetching data:', error);
    }


    const onCellClicked = (event) => {
        setSelectedDebtorId(event.data.debtorid);
        setIsModalOpen(true);
    };

    const closeModal = () => {
        setIsModalOpen(false);
    };

    const customSelectStyles = {
        menuPortal: (provided) => ({
            ...provided,
            zIndex: 9999,
        }),
    };

    return (
        <div>
            <Row>
                 <Col>
                     <h4 className='margin'>{reportName}</h4>
                 {error && <div className="error-message">Error fetching data: {error.message}</div>}
                </Col>
                 <Col className='export-button'>
                     <Button variant='secondary' onClick={onBtnExport}>Download CSV</Button>
                 </Col>
 
                 </Row>
            <Row className='mb-3'>
                <Col md={4}>
                    <Form.Group>
                        <Form.Label>Filter by Client</Form.Label>
                        <Select
                            options={clientOptions}
                            value={selectedClient}
                            onChange={setSelectedClient}
                            placeholder="Select a client..."
                            isClearable
                            menuPortalTarget={document.body}
                            styles={customSelectStyles}
                        />
                    </Form.Group>
                </Col>
            </Row>
             
            
            <div className="ag-theme-quartz compact-theme grid">
                <AgGridReact
                    rowData={rowData}
                    columnDefs={columnDefs}
                    defaultColDef={{ sortable: true, filter: true }}
                    onCellClicked={onCellClicked}
                    onFirstDataRendered={(params) => params.api.sizeColumnsToFit()}
                    onGridReady={onGridReady}

                />
            </div>
            {isModalOpen && (
                <CollectorClaimModal

                    selectedClaim={selectedDebtorId}
                    setSelectedClaim={setSelectedDebtorId}
                    onGridReady={onGridReady}
                    defaultColDef={{ sortable: true, filter: true }}
                    show={isModalOpen}
                    setShow={closeModal}
                />
            )}
        </div>
    );
};

export default ReportTemplateCSVClick;